import React, { useCallback, useMemo } from 'react';
import Icon from '../../../../../../components/Icon';
import IconWrap from '../../../../../../components/IconWrap';
import TableAdvanced from '../../../../../../components/TableAdvanced';
import RowSubComponent from '../RowSubComponent';
import Place from '../../../../../../components/Place';
import { useTranslation } from 'react-i18next';

const TablePlaces = ({ places, handleClickEdit, handleClickDelete }) => {
    const { t } = useTranslation()
    const columns = useMemo(() => [
        {
            Header: t('Obiekt'),
            accessor: 'name',
            Cell: ({ row, cell: { value } }) => {
                const logo = row.original?.logo;

                return (
                    <Place
                        name={value}
                        logo={logo}
                    />
                );
            }
        },
        {
            Header: t('Lokalizacja'),
            accessor: 'address'
        },
        {
            Header: () => null,
            id: 'expander',
            disableResizing: true,
            Cell: ({ row }) => (
                <IconWrap rotate={row.isExpanded ? 0 : -180} align="right">
                    <Icon name="arrow" />
                </IconWrap>
            ),
            width: 30
        },
    ], [t]);

    const renderRowSubComponent = useCallback(
        ({ row, visibleColumns }) => (
            <RowSubComponent
                row={row}
                visibleColumns={visibleColumns}
                onClickEdit={handleClickEdit}
                onClickRemove={handleClickDelete}
            />
        ),
        [handleClickEdit, handleClickDelete]
    );

    const data = useMemo(() => places, [places]);

    return (
        <TableAdvanced
            columns={columns}
            data={data}
            renderRowSubComponent={renderRowSubComponent}
        />
    )
}

export default TablePlaces;
